import { render, staticRenderFns } from "./MobileTab.vue?vue&type=template&id=2a40b65c&"
import script from "./MobileTab.vue?vue&type=script&lang=js&"
export * from "./MobileTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports